var _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "archive-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg archive",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "20 0 21.8 1.8 28 1.8 28 5.3 3.2 5.3 3.2 1.8 9.4 1.8 11.2 0 20 0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,7.1V28.4a3.48,3.48,0,0,0,3.5,3.5H22.8a3.48,3.48,0,0,0,3.5-3.5V7.1ZM22.7,28.4H8.5V10.6H22.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.96402ad8692baa403404b4533f6648fc.svg";
export { ForwardRef as ReactComponent };